// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.vertical-separator-core-container{background-color:#d7d8dd;width:1px}`, "",{"version":3,"sources":["webpack://./src/core/coreComponents/VerticalSeparatorCore/vertical-separator-core.scss"],"names":[],"mappings":"AAAA,mCACE,wBAAA,CACA,SAAA","sourcesContent":[".vertical-separator-core-container {\r\n  background-color: #D7D8DD;\r\n  width: 1px;\r\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
